module.exports = __webpack_public_path__ + "snow.d6d47d0e429a2d70c733.jpg";


//////////////////
// WEBPACK FOOTER
// C:/dev/Perso/urmeo/src/assets/snow.jpg
// module id = ../../../../../src/assets/snow.jpg
// module chunks = styles